module.exports = __webpack_public_path__ + "static/media/crm-auth-reset-password-email-succeed-image.8ee7b349.svg";